module.exports = __webpack_public_path__ + "img/457.a3b61d6e.png";